import once from 'lodash/once';
import Tracking from '@spotahome/soyuz-tracking';

import {
  InstanceManager,
  EcommerceManagerFactory
} from '@spotahome/marketplace-common/src/tracking';

const homecardListTracking = cityId => {
  const clientTrackingInstance = InstanceManager.getClientSideInstance();
  const ecommerceManager = EcommerceManagerFactory(clientTrackingInstance);

  const triggerHotjarPermanentBookingRecording = once(() => {
    Tracking.hotjar.triggerEvent('permanent_booking_search');
  });

  const trackProductImpressions = (cardList, indexedHomecards) => {
    try {
      ecommerceManager.trackSearchPageImpressions(
        cardList,
        indexedHomecards,
        cityId
      );
    } catch (err) {
      console.error(err);
    }
  };

  const trackHomecardClick = (position, cardData) => {
    ecommerceManager.trackSearchPageHomecardClick(cardData, position, cityId);
  };

  const triggerHotjarRecording = (homecards = {}) => {
    const hasHomecardWithPermanentDuration = Object.values(homecards).find(
      homecard => homecard.allowsPermanentContract
    );

    if (hasHomecardWithPermanentDuration) {
      triggerHotjarPermanentBookingRecording();
    }
  };

  return {
    trackInitialMount: (markerList, homecards) => {
      trackProductImpressions(markerList, homecards);
      triggerHotjarRecording(homecards);
    },
    trackProductImpressions,
    trackHomecardClick,
    triggerHotjarRecording
  };
};

export default homecardListTracking;
